import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Schedule } from 'models/ScheduleModel';



const ScheduleList: React.FC = () => {
  const width = { doctor: 20, location: 15, date: 15, start: 10, end: 10, comment:24 }
  const [formId, formName] = [Code.Form.Id.SCHEDULE, Code.Form.Name.SCHEDULE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [scheduleData, setScheduleData] = useState<Schedule[]>([]); 
  const [selectedSchedule, setselectedSchedule] = useState<Schedule | null>(null);
  const [doctorId, setDoctorId] = useState<number>(1);
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, doctorId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.DOCTOR, Code.Option.Common.ALL, setDoctorOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Schedule.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Doctor.FullName,
        Name.Schedule.StartDate, 
        Name.Schedule.StartTime, 
        Name.Schedule.EndTime, 
        Name.Common.BranchName, 
        Name.Schedule.Comment, 
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
      ...(doctorId != 1 && { doctor_id: doctorId }),
    });
     
    await API.Data.List<Schedule>(url, setScheduleData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {/* <Button.Create title={"Multiple"} onClick={() => Form.Show.Popup(iframeRef, "multischedule")} Privilege={Privilege} /> */}
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Doctor} value={doctorId} options={doctorOptions} onChange={(value) => { setDoctorId(value);  callListData();  }} />
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, scheduleData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Doctor, width.doctor], 
                [Title.Location, width.location], 
                [Title.Date, width.date], 
                [Title.Start, width.start], 
                [Title.End, width.end],
                [Title.Comment, width.comment], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(scheduleData) && (
              <Control.Grid.Row>
                {scheduleData.map((scheduleData) => { return (
                <Control.Grid.Data<Schedule> key={scheduleData.schedule_id} itemKey={scheduleData.schedule_key} data={scheduleData} setMenuPosition={setMenuPosition} setSelectedData={setselectedSchedule} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={scheduleData.schedule_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, scheduleData.schedule_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [Utility.Get.FullName(scheduleData,Code.Form.Name.DOCTOR), width.doctor],
                    [scheduleData.branch_name, width.location],
                    [Utility.Format.DateOnly(scheduleData.schedule_start_date), width.date],
                    [Utility.Format.Time(scheduleData.schedule_start_time), width.start],
                    [Utility.Format.Time(scheduleData.schedule_end_time), width.end],
                    [scheduleData.schedule_comment, width.comment],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={scheduleData.schedule_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={scheduleData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedSchedule?.schedule_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedSchedule?.schedule_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ScheduleList;